import {computed} from "vue";

const isOnLocalDomain = computed(() => (document?.querySelector('meta[name="local-domain" i]')?.getAttribute('content')) === 'true');
const seoAgentName = computed(() => (document?.querySelector('meta[name="seo-agent-name" i]')?.getAttribute('content')));
const seoAgentIcon = computed(() => (document?.querySelector('meta[name="seo-agent-icon" i]')?.getAttribute('content')));
const hasCustomDomainSetup = computed(() => (document?.querySelector('meta[name="has-custom-domain-setup" i]')?.getAttribute('content')));

const kitName = computed(() => seoAgentName.value);

const platformName = computed(() => isOnLocalDomain.value ? 'Hike' : 'the platform')

export {
  isOnLocalDomain,
  kitName,
  seoAgentIcon,
  hasCustomDomainSetup,
  platformName,
};
